"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get getGitHashForFiles () {
        return getGitHashForFiles;
    },
    get getPackageDeps () {
        return getPackageDeps;
    },
    get gitLsTree () {
        return gitLsTree;
    },
    get gitStatus () {
        return gitStatus;
    },
    get parseGitFilename () {
        return parseGitFilename;
    },
    get parseGitLsTree () {
        return parseGitLsTree;
    },
    get parseGitStatus () {
        return parseGitStatus;
    }
});
const _path = /*#__PURE__*/ _interop_require_wildcard(require("path"));
const _execa = /*#__PURE__*/ _interop_require_default(require("execa"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function parseGitFilename(filename) {
    // If there are no double-quotes around the string, then there are no escaped characters
    // to decode, so just return
    if (!filename.match(/^".+"$/)) {
        return filename;
    }
    // Need to hex encode '%' since we will be decoding the converted octal values from hex
    filename = filename.replace(/%/g, "%25");
    // Replace all instances of octal literals with percent-encoded hex (ex. '\347\275\221' -> '%E7%BD%91').
    // This is done because the octal literals represent UTF-8 bytes, and by converting them to percent-encoded
    // hex, we can use decodeURIComponent to get the Unicode chars.
    filename = filename.replace(/(?:\\(\d{1,3}))/g, (match, ...[octalValue, index, source])=>{
        // We need to make sure that the backslash is intended to escape the octal value. To do this, walk
        // backwards from the match to ensure that it's already escaped.
        const trailingBackslashes = source.slice(0, index).match(/\\*$/);
        return trailingBackslashes && trailingBackslashes.length > 0 && trailingBackslashes[0].length % 2 === 0 ? `%${parseInt(octalValue, 8).toString(16)}` : match;
    });
    // Finally, decode the filename and unescape the escaped UTF-8 chars
    return JSON.parse(decodeURIComponent(filename));
}
function parseGitLsTree(output) {
    const changes = new Map();
    if (output) {
        // A line is expected to look like:
        // 100644 blob 3451bccdc831cb43d7a70ed8e628dcf9c7f888c8    src/typings/tsd.d.ts
        // 160000 commit c5880bf5b0c6c1f2e2c43c95beeb8f0a808e8bac  rushstack
        const gitRegex = /([0-9]{6})\s(blob|commit)\s([a-f0-9]{40})\s*(.*)/;
        // Note: The output of git ls-tree uses \n newlines regardless of OS.
        const outputLines = output.trim().split("\n");
        for (const line of outputLines){
            if (line) {
                // Take everything after the "100644 blob", which is just the hash and filename
                const matches = line.match(gitRegex);
                if (matches && matches[3] && matches[4]) {
                    const hash = matches[3];
                    const filename = parseGitFilename(matches[4]);
                    changes.set(filename, hash);
                } else {
                    throw new Error(`Cannot parse git ls-tree input: "${line}"`);
                }
            }
        }
    }
    return changes;
}
function parseGitStatus(output) {
    const changes = new Map();
    /*
   * Typically, output will look something like:
   * M temp_modules/rush-package-deps-hash/package.json
   * D package-deps-hash/src/index.ts
   */ // If there was an issue with `git ls-tree`, or there are no current changes, processOutputBlocks[1]
    // will be empty or undefined
    if (!output) {
        return changes;
    }
    // Note: The output of git hash-object uses \n newlines regardless of OS.
    const outputLines = output.trim().split("\n");
    for (const line of outputLines){
        /*
     * changeType is in the format of "XY" where "X" is the status of the file in the index and "Y" is the status of
     * the file in the working tree. Some example statuses:
     *   - 'D' == deletion
     *   - 'M' == modification
     *   - 'A' == addition
     *   - '??' == untracked
     *   - 'R' == rename
     *   - 'RM' == rename with modifications
     *   - '[MARC]D' == deleted in work tree
     * Full list of examples: https://git-scm.com/docs/git-status#_short_format
     */ const match = line.match(/("(\\"|[^"])+")|(\S+\s*)/g);
        if (match && match.length > 1) {
            const [changeType, ...filenameMatches] = match;
            // We always care about the last filename in the filenames array. In the case of non-rename changes,
            // the filenames array only contains one file, so we can join all segments that were split on spaces.
            // In the case of rename changes, the last item in the array is the path to the file in the working tree,
            // which is the only one that we care about. It is also surrounded by double-quotes if spaces are
            // included, so no need to worry about joining different segments
            let lastFilename = changeType.startsWith("R") ? filenameMatches[filenameMatches.length - 1] : filenameMatches.join("");
            lastFilename = parseGitFilename(lastFilename);
            changes.set(lastFilename, changeType.trimRight());
        }
    }
    return changes;
}
function getGitHashForFiles(filesToHash, packagePath, gitPath) {
    const changes = new Map();
    if (filesToHash.length) {
        // Use --stdin-paths arg to pass the list of files to git in order to avoid issues with
        // command length
        const result = _execa.default.sync(gitPath || "git", [
            "hash-object",
            "--stdin-paths"
        ], {
            input: filesToHash.map((x)=>_path.resolve(packagePath, x)).join("\n")
        });
        if (result.exitCode !== 0) {
            throw new Error(`git hash-object exited with status ${result.exitCode}: ${result.stderr}`);
        }
        const hashStdout = result.stdout.trim();
        // The result of "git hash-object" will be a list of file hashes delimited by newlines
        const hashes = hashStdout.split("\n");
        if (hashes.length !== filesToHash.length) {
            throw new Error(`Passed ${filesToHash.length} file paths to Git to hash, but received ${hashes.length} hashes.`);
        }
        for(let i = 0; i < hashes.length; i++){
            const hash = hashes[i];
            const filePath = filesToHash[i];
            changes.set(filePath, hash);
        }
    }
    return changes;
}
function gitLsTree(path, gitPath) {
    const result = _execa.default.sync(gitPath || "git", [
        "ls-tree",
        "HEAD",
        "-r"
    ], {
        cwd: path
    });
    if (result.exitCode !== 0) {
        throw new Error(`git ls-tree exited with status ${result.exitCode}: ${result.stderr}`);
    }
    return result.stdout;
}
function gitStatus(path, gitPath) {
    /**
   * -s - Short format. Will be printed as 'XY PATH' or 'XY ORIG_PATH -> PATH'. Paths with non-standard
   *      characters will be escaped using double-quotes, and non-standard characters will be backslash
   *      escaped (ex. spaces, tabs, double-quotes)
   * -u - Untracked files are included
   *
   * See documentation here: https://git-scm.com/docs/git-status
   */ const result = _execa.default.sync(gitPath || "git", [
        "status",
        "-s",
        "-u",
        "."
    ], {
        cwd: path
    });
    if (result.exitCode !== 0) {
        throw new Error(`git status exited with status ${result.exitCode}: ${result.stderr}`);
    }
    return result.stdout;
}
function getPackageDeps(packagePath = process.cwd(), excludedPaths, gitPath) {
    const gitLsOutput = gitLsTree(packagePath, gitPath);
    // Add all the checked in hashes
    const result = parseGitLsTree(gitLsOutput);
    // Remove excluded paths
    if (excludedPaths) {
        for (const excludedPath of excludedPaths){
            result.delete(excludedPath);
        }
    }
    // Update the checked in hashes with the current repo status
    const gitStatusOutput = gitStatus(packagePath, gitPath);
    const currentlyChangedFiles = parseGitStatus(gitStatusOutput);
    const filesToHash = [];
    const excludedPathSet = new Set(excludedPaths);
    for (const [filename, changeType] of currentlyChangedFiles){
        // See comments inside parseGitStatus() for more information
        if (changeType === "D" || changeType.length === 2 && changeType.charAt(1) === "D") {
            result.delete(filename);
        } else {
            if (!excludedPathSet.has(filename)) {
                filesToHash.push(filename);
            }
        }
    }
    const currentlyChangedFileHashes = getGitHashForFiles(filesToHash, packagePath, gitPath);
    for (const [filename, hash] of currentlyChangedFileHashes){
        result.set(filename, hash);
    }
    return result;
}
